(function($) {
    $(function() {
        $('#contact-page-form').submit(function(e) {
            e.preventDefault();

            // Error checking
            var contactFormTimeoutDelay = 5000;
            var hasErrors = false;
            var contactForm = $(this);
            var formData = contactForm.serialize();

            var fields = ['cffirstname', 'cfsurname', 'cfphone', 'cfemail', 'cfmessage'];
            var field_count = fields.length;
            var valid_fields = 0;

            $.each(fields, function(i, value) {
                if ($('#' + value).val() == '') {
                    $('#' + value).addClass('has-error');

                    hasErrors = true;
                } else {
                    valid_fields++;

                    $('#' + value).removeClass('has-error');
                }
            });

            if (field_count == valid_fields) {
                $('.alert-danger.incomplete').addClass('hide');
            }

            if (!$("input[name='cfenquiry']:checked").val()) {
                $("input[name='cfenquiry']").parent().addClass('has-error');

                hasErrors = true;
            } else {
                $("input[name='cfenquiry']").parent().removeClass('has-error');
            }

            if ($('.g-recaptcha-response').val() == '') {
                hasErrors = true;

                $('.alert-danger.contact-form-captcha').removeClass('hide');
            } else {
                $('.alert-danger.contact-form-captcha').addClass('hide');
            }

            // If errors are found, show the error notification
            if (hasErrors) {
                $('.alert-danger.incomplete').removeClass('hide');
                // Go back to the top of the page
                $('html, body').animate({ scrollTop: 0 }, 0);

                return false;
            }

            // If we get this far the form has been filled in correctly and we can proceed with sending the data
            $.ajax({
                type: 'POST',
                dataType: "json",
                url: contact_page_form.ajaxurl,
                data: {
                    action: 'drp-contact-form-handle',
                    formData: formData,
                },
                success: function(data) {
                    if (data.error == false) {
                        // Send to the contact form response to the Analytics AJAX handler
                        var analyticsData = {
                            'name': $('#cffirstname').val() + ' ' + $('#cfsurname').val(),
                            'phone': $('#cfphone').val(),
                            'email': $('#cfemail').val(),
                            'message': $('#cfmessage').val(),
                            'enquiry': $('input[name="cfenquiry"]:checked').val()
                        };
                        analyticsTracking('contactPageFormSubmit', analyticsData);

                        // Hide all error notifications
                        $('.alert-danger').addClass('hide');

                        // Remove all error classes from the form
                        $('select, input, textarea, checkbox, radio', contactForm).each(function() {
                            $(this).removeClass('has-error');
                            // And the checkbox
                            $(this).parent().removeClass('has-error');

                            hasErrors = false;
                        });

                        // Show the success notification
                        $('.alert-success').removeClass('hide');

                        // Reset the form fields
                        contactForm.trigger('reset');
                        // Reset the captcha
                        grecaptcha.reset();
                    } else {
                        // Show the error notification
                        $('.alert-danger.general-error').html('<p>Something went wrong, your message was not sent.</p>');
                        $('.alert-danger.general-error').removeClass('hide');

                        if (data.captcha) {
                            // Reset the captcha
                            grecaptcha.reset();

                            $('.alert-danger.contact-form-captcha').removeClass('hide');
                        }
                    }
                }
            });
        });
    });
})(jQuery);
